import useSWR from 'swr';
import axiosSWRFetcher from '../utils/swrFetcher';

export default function useGoals(companyId, crewId) {
  const { data, error, isValidating, mutate } = useSWR(
    companyId ? `/api/works/goal/company/${companyId}/crew/${crewId}/` : null,
    axiosSWRFetcher,
    {
      errorRetryInterval: 2000,
      revalidateOnFocus: false
    }
  );

  return {
    goals: data?.goals || [],
    totalGoals: data?.total || 0,
    isLoading: !error && !data,
    isValidating,
    isError: error,
    mutate,
  };
};
